import React from 'react';
import clsx from 'clsx';
import { number, object, string, oneOfType, bool, node } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Image from '../Image';
import Typography from '../Typography';
import useStyles from './styles';

const Title = ({
  content,
  size = 35,
  src,
  icon,
  values,
  downSized = false,
  status,
  substatus,
  isPublicApiV4,
  modalName,
  titleStyle,
  style,
  alignItem = 'center',
}) => {
  const classes = useStyles({ downSized });

  return (
    <Grid name="title" container className={classes.container} direction="column" alignItems="center">
      {!isPublicApiV4 && src && (
        <Grid item>
          <Image name={src} height={downSized ? 30 : size} width={downSized ? 30 : size} />
        </Grid>
      )}
      {icon && <Grid item>{icon}</Grid>}
      {content && (
        <Grid
          item
          container
          direction="row"
          justify={modalName === 'contextGarageNetwork' ? 'left' : alignItem}
          alignItems="baseline"
          className={classes.spacing}
        >
          {
            <Typography
              content={content}
              values={values}
              variant="h6"
              className={downSized ? clsx(titleStyle, classes.downSizedFont) : titleStyle}
              style={style}
            />
          }
          {isPublicApiV4 && status && <Typography content={status} className={classes.status} />}
        </Grid>
      )}
      {isPublicApiV4 && substatus && <Typography content={substatus} className={classes.substatus} />}
    </Grid>
  );
};

Title.propTypes = {
  content: oneOfType([number.isRequired, object.isRequired, string.isRequired]),
  size: number,
  src: string,
  values: object,
  downSized: bool,
  status: object,
  substatus: object,
  isPublicApiV4: bool,
  modalName: string,
  icon: node,
  titleStyle: object,
  style: object,
  alignItem: string,
};

export default Title;
